import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useHomeHero } from '../data';
import useSlider from '../components/useSlider';
import ExploreLink from '../components/ExploreLink';
import ParticleField from '../components/ParticleField';

// §7.1.1 — full-bleed hero slider with left overlay panel, edge chevrons, autoplay.
export default function HomeHero() {
  const slides = useHomeHero().slice().sort((a, b) => a.order - b.order);
  const { index, next, prev, goTo, hoverHandlers } = useSlider(slides.length, 6000);

  if (!slides.length) return null;

  return (
    <section className="hero" aria-roledescription="carousel" aria-label="Highlights" {...hoverHandlers}>
      <div className="hero__slides">
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`hero__slide${i === index ? ' is-active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
            aria-hidden={i !== index}
          />
        ))}
        <div className="hero__overlay" />
      </div>

      <ParticleField count={14} className="hero__particles" />

      <div className="container hero__content">
        <div className="hero__panel">
          <p className="hero__text">{slides[index].bodyText}</p>
          <ExploreLink href={slides[index].ctaHref} label={slides[index].ctaLabel} />
        </div>
      </div>

      <button className="hero__arrow hero__arrow--prev" onClick={prev} aria-label="Previous slide">
        <ChevronLeft size={32} />
      </button>
      <button className="hero__arrow hero__arrow--next" onClick={next} aria-label="Next slide">
        <ChevronRight size={32} />
      </button>

      <div className="hero__dots" role="tablist" aria-label="Choose slide">
        {slides.map((s, i) => (
          <button
            key={s.id}
            className={`hero__dot${i === index ? ' is-active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
            aria-selected={i === index}
            role="tab"
          />
        ))}
      </div>
    </section>
  );
}
